import React from "react";
import PropTypes from "prop-types";
import get from "lodash.get";
import { injectIntl } from "react-intl";

import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";

import ParkkiTheme from "themes/ParkkiTheme";
import Table from "components/Table";

const styles = {
  container: {
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    marginTop: ParkkiTheme.spacings.base,
  },
  tableRowContainer: {
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  reportTitle: {
    width: "100%",
  },
  pdfListContainer: {
    width: "87%",
  },
  info: {
    fontSize: ParkkiTheme.fontSizes.small,
  },
  tableRow: {
    cursor: "pointer",
  },
  tableColumn: {
    fontSize: "10px",
  },
  tableRowSelected: {
    backgroundColor: "#BDC3C7",
  },
  infoContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    marginTop: ParkkiTheme.spacings.base,
    fontSize: ParkkiTheme.fontSizes.xsmall,
    flexDirection: "column",
  },
};

class PDFList extends React.PureComponent {
  handleChangePage = (event, page) => {
    const { setPage } = this.props;
    setPage(page);
  };

  handleChangeRowsPerPage = (event) => {
    const { setRowsPerPage } = this.props;
    setRowsPerPage(event.target.value);
  };

  handleRowSelection = (selectedIndex) => {
    if (get(this.props.list, "selectedIndex") === selectedIndex) {
      this.props.onRowSelection(null);
    } else {
      this.props.onRowSelection(selectedIndex);
    }
    return selectedIndex;
  };

  getTableRowStyle = (index) => {
    if (index === null) {
      return styles.tableRow;
    }

    const otherStyle =
      get(this.props.list, "selectedIndex") === index
        ? styles.tableRowSelected
        : {};
    return { ...styles.tableRow, ...otherStyle };
  };

  renderTableContent = () => {
    const { list, onRowHover } = this.props;

    return get(list, "items", []).map((report, index) => {
      return (
        <TableRow
          hover
          onClick={() => this.handleRowSelection(index)}
          style={this.getTableRowStyle(index)}
          onMouseOver={(e) => onRowHover(index)}
          onMouseLeave={() => onRowHover(null)}
          key={index}
        >
          <TableCell style={styles.tableColumn}>
            <div style={styles.tableRowContainer}>
              <div style={styles.reportTitle}>{get(report, "title", "")}</div>
              <KeyboardArrowRight />
            </div>
          </TableCell>
        </TableRow>
      );
    });
  };

  render() {
    const { intl, list, loading } = this.props;
    const { items, length, page, rowsPerPage } = list;

    return (
      <div style={styles.container}>
        <div style={styles.pdfListContainer}>
          <Table
            toggleRowIfAnyResult={false}
            loading={loading}
            headItems={null}
            items={items}
            pagination={{
              length,
              rowsPerPage,
              page,
              changePage: this.handleChangePage,
              changeRowsPerPage: this.handleChangeRowsPerPage,
            }}
          >
            {this.renderTableContent()}
          </Table>
        </div>
        {!loading && get(items, "length", 0) === 0 && (
          <div style={styles.infoContainer}>
            <div>{intl.messages["analysisScene.noReport"]}</div>
          </div>
        )}
      </div>
    );
  }
}

PDFList.defaultProps = {
  title: "",
  loading: false,
};

PDFList.propTypes = {
  title: PropTypes.string,
  loading: PropTypes.bool,
  list: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    length: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    orders: PropTypes.object,
  }).isRequired,
  onRowHover: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  setRowsPerPage: PropTypes.func.isRequired,
};

export default injectIntl(PDFList);
